var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "12px",
    viewBox: "0 0 24 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-3-Copy-14",
    transform: "translate(-400.000000, -3268.000000)",
    fill: "#161618",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right-arrow-(1)",
    transform: "translate(412.000000, 3274.000000) scale(-1, 1) translate(-412.000000, -3274.000000) translate(400.000000, 3268.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7250195,5.31498354 C23.7247382,5.31469322 23.7245039,5.31435451 23.7241757,5.31406419 L18.8255532,0.281803294 C18.458569,-0.0951807889 17.8649911,-0.0937775623 17.4996944,0.285093618 C17.1344446,0.663916412 17.1358509,1.27664256 17.5028351,1.65367503 L20.7917709,5.03225758 L0.937499535,5.03225758 C0.419718542,5.03225758 0,5.46551588 0,6 C0,6.53448423 0.419718542,6.96774254 0.937499535,6.96774254 L20.7917241,6.96774254 L17.5028819,10.3463251 C17.1358977,10.7233575 17.1344915,11.3360837 17.4997413,11.7149065 C17.865038,12.0938261 18.4586627,12.0951325 18.8256,11.7181968 L23.7242226,6.68593593 C23.7245039,6.6856456 23.7247382,6.68530689 23.7250664,6.68501657 C24.092238,6.30672603 24.0910662,5.69201601 23.7250195,5.31498354 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow2);
export default __webpack_public_path__ + "static/media/left-arrow2.6ec7abd6607fad22eea45c61a4988d17.svg";
export { ForwardRef as ReactComponent };